import React, { Component } from 'react';

import classes from './SlidePanel.css';
import Box from '../../../hoc/Box/Box';
import Backdrop from '../Backdrop/Backdrop';

class SlidePanel extends Component {

    shouldComponentUpdate ( nextProps, nextState ) {
        return nextProps.show !== this.props.show || nextProps.children !== this.props.children;
    }
    
    render () {
     
        return (
            <Box>            
                {/* <Backdrop show={this.props.show} clicked={this.props.modalClosed} /> */}
                <div
                    className={ classes.devDeetsModal}
                    style={{
                        transform: this.props.show ? 'translateX(0)' : 'translateX(100vw)',
                        opacity: this.props.show ? '1' : '0',
                        overflow:this.props.scrollable ? 'scroll': '',
                        backgroundColor: this.props.backgroundColor ?? 'white' 
                    }}>
                    {this.props.children}
                </div>
               
            </Box>
        )
    }
}

export default SlidePanel;